import React, { useRef, useEffect } from 'react';

export default function TermsOfServiceModal({ isOpen, onClose, darkMode }) {
  const modalRef = useRef();

  const termsOfServiceContent =
// `**Willkommen to Our Unparalleled Service!**
//
//   In the grand tradition of German efficiency and precision, we hereby decree the rules of engagement with our superior service. Pay attention, for your compliance is mandatory, less you find yourself cast out into the digital wilderness.
//
//   - **Regulations of Utilization**: Your license to harness our service is contingent upon your strict adherence to our edicts. Engage not in the dark arts of lawbreaking, data pilferage, or the infliction of digital despair upon others.
//
//   - **Sanctity of Privacy**: Much like the vaults of a Swiss bank, we guard your privacy with zeal. Your continued use of our service signifies your unspoken pact with our Privacy Policy, a tome detailing our sacred handling of your personal dossier.
//
//   - **Evolutions and Mutations**: As the Bavarian forests transform with the seasons, so too may our service and its governing terms. Your unwavering loyalty and continued use post-alteration signify your tacit endorsement of our enhancements.
//
//   - **Absence of Guarantees**: Our service is bestowed upon you in its pure, unadulterated form, devoid of any promises of perfection. We renounce all claims of our service being impervious to flaws, vulnerabilities, or interruptions.
//
//   - **Limitation of Liability**: Should you find yourself ensnared in digital thorns or suffering the slings and arrows of outrageous fortune due to our service, know that we shall observe from afar, absolved of all accountability. Venture forth at your own peril.
//
//   - **Jurisdictional Commandments**: The iron-clad laws of [Your Country] shall reign supreme over these terms, a testament to our legal allegiance.
//
//     Should you require counsel or wish to dispatch a missive, direct your communications to [Your Contact Information].
//
//   We extend our gratitude for your allegiance to our service. Now, proceed with caution, for your tenure here is as precarious as a leaf on the Autobahn.
// `
    `February 27, 2024
Dear Ben,

As your President, I have pledged to keep you as informed as possible on key litigation events as they occur. Yesterday, C.A.R. was named as a defendant in a second copycat class action antitrust lawsuit filed in California federal court (Central District). The lawsuit, Freedlund v. Redfin Corporation et al., is against NAR, Redfin and C.A.R. Similar to the Fiero suit filed last month, this new lawsuit alleges that the defendants conspired to engage in anticompetitive conduct relating to NAR’s cooperative compensation rule.  The plaintiff is an individual who sold her house in 2021 and was represented by a Redfin agent in that transaction. 

As I noted last month when I updated you about the first lawsuit, we believe these allegations are without merit for several reasons, and we are ready to present those arguments in court. C.A.R. has retained highly experienced antitrust defense counsel to work with our own legal team. As a reminder, due to the current litigation against C.A.R. and various other ongoing antitrust cases, C.A.R. will not comment on aspects of this case; however, we will continue to do our best to keep you informed of significant developments to the extent appropriate.

You know well how to represent your value to clients, and I know you do this every day. Please continue to have transparent discussions with your clients about how you are paid, and how compensation is structured. C.A.R. has proactively provided you with numerous resources to help you demonstrate your value to clients, and we hope you utilize these resources freely. C.A.R.’s list of 167 things REALTORS® do for their clients can be found on Smart Zone, our specially created website to help you navigate a challenging market. You’ll also find buyer agent resources, including legal guides, and educational resources for using the Buyer Representation and Broker Compensation Form, as well as business and legal tools on this site.

Thank you, as always, for your support, and know that we will continue to vigorously defend the Association and its practices to the best of our abilities.


Sincerely,

Melanie Barker
2024 C.A.R. President
`

  useEffect(() => {
  }, [isOpen]);

  const handleDecline = () => {
    window.location.href = '/login';
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-300 transition-opacity" aria-hidden="true"></div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <div
          ref={modalRef}
          className="inline-block align-bottom bg-white dark:bg-stone-800 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className={`bg-white dark:bg-stone-800 ${darkMode ? 'text-gray-300' : 'text-gray-700'} rounded-lg px-4 pt-5 pb-4 sm:p-6 sm:pb-4`}>
            <div className="mt-3 text-center sm:mt-0 sm:text-left">
              <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white" id="modal-headline">
                Terms of Service Agreement
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {termsOfServiceContent}
                </p>
              </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                className="mt-6 w-32 inline-flex items-center font-semibold justify-center px-4 py-2 border border-transparent text-base rounded-md text-white bg-blue-600 hover:bg-blue-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
                onClick={onClose}
              >
                Accept
              </button>
              <button
                onClick={handleDecline}
                type="button"
                className="mt-6 mr-3 w-32 inline-flex ml-2 items-center font-semibold justify-center px-4 py-2 border text-base rounded-md text-white bg-red-500 hover:bg-red-700 border-red-700"
                style={{transition: 'background-color 0.9s'}}
              >
                <span>Decline</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
